import {productPaths, warrantiesPaths} from '~/utils/services/paths';
import type {
    ICatMan, ICpArticle, IPaginatedResponse, IProductReview,
    IWarranty, IWishlist, SortReviewsOptions, IArticleWarrantySupplier,
} from '~/types';
import {$cpFetch} from '~/composables/useCpFetch';
import type {IQuestion} from '~/utils/fixtures/QnA.fixtures';

interface ICpSpec {
    specs: {
        [key: string]: {
            title: string;
            value: string;
        };
    };
    title: string;
}
interface ICpShoppingTools {
    cpactive_from: string;
    cpactive_to: string;
    cpbutton_text: string;
    cpdescription: string;
    cpexcluded_brands: string;
    cplink: string;
    cppicture: string;
    cppicture_pdp: string;
    cptitle: string;
    f_oxmanufacturer: string | null;
}
interface ICpAccessoryArticle {
    firstBuyable: unknown[];
    id: string;
    link: string;
    oldPrice: string;
    picture: string;
    pictureMask: string;
    price: string;
    showStars: boolean;
    sku: string;
    starsWidth: string;
    stock: number;
    title: string;
}
interface ICpAccessory {
    articles: Array<ICpAccessoryArticle>;
    category: ICatMan
}
interface ICpBreadcrumb {
    id: string | null;
    image: string | null;
    title: string;
    url: string;
}
export interface IProductDetails {
    accessories: Array<ICpAccessory>;
    allOffersLink: string;
    answerCount: number;
    article: ICpArticle;
    boldTitle: string;
    breadCrumbs: Array<ICpBreadcrumb>;
    categoryAncestors: Array<string>;
    compatibleProducts: Array<unknown>;
    consumables: Array<unknown>;
    description: string;
    isMobile: boolean;
    largePictures: Array<string>;
    lastSeen: Array<unknown>;
    licenses: Array<unknown>;
    linkToCompare: ICpBreadcrumb;
    mainSpecs: Array<{ title: string; value: string }>;
    metaDesc?: string
    moreInfo: Array<unknown>;
    nostoCategoryPath: string;
    nostoOthersSaw: Array<unknown>;
    originalArticle: string;
    originalManufacturer: string;
    parentCrossSelling: Array<unknown>;
    questionsAndAnswers: Array<unknown>;
    reviews: Array<unknown>;
    seeMore: Array<unknown>;
    selfActionLink: string;
    shoppingTools: ICpShoppingTools;
    shortAttributeList: string;
    showCostPerPage: boolean;
    showHpMedallion: boolean;
    seoTitle: string;
    socialLink: string;
    socialLinkShort: string;
    socialMediaPicture: string;
    socialTitle: string;
    spareParts: Array<unknown>;
    toBasketLink: string;
    variants: Array<{
        url: string,
        image: string,
        description: string
    }>;
    warranties: Array<IWarranty>;
    xLargePictures: Array<string>;
    specs?: Array<ICpSpec>;
    questionsLink: string;
    writeReviewLink?: string;
    iframeUrlDescription?: string,
    longDescriptionUrl?: string,
}
export type IProductReviewResponse = IPaginatedResponse<IProductReview>
export interface IReviewsPagination {
    productId: string;
    pageNumber?: number;
    pageSize?: number;
    /** rating filter */
    rating?: number;
    search?: string;
    sortType?: SortReviewsOptions;
}

export interface NewReview {
    comment: string;
    stars: 0 | 1 | 2 | 3 | 4 | 5;
    title: string;
    user: string;
}


export const getProductDetails = (id: string) => {
    return $cpFetch<IProductDetails>(productPaths.details(id));
};


export const getProductWishlists = (id: string) => {
    return $cpFetch<Array<IWishlist>>(productPaths.wishlist(id));
};

export const getWarrantySupplier = (articleId: string) => {
    const options = {
        method: 'GET',
        withoutAuthorization: true,
        useMS: true,
    };
    return $cpFetch<IArticleWarrantySupplier>(warrantiesPaths.getWarrantySupplier(articleId), options);
};
